import { render } from "./PoweredByFooter.vue?vue&type=template&id=225b6c5e&ts=true"
import script from "./PoweredByFooter.vue?vue&type=script&lang=ts"
export * from "./PoweredByFooter.vue?vue&type=script&lang=ts"

import "./PoweredByFooter.vue?vue&type=style&index=0&id=225b6c5e&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__